"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const users_1 = require("./users");
const featureFlagsDetailData_1 = require("./featureFlagsDetailData");
exports.appSettingsDetailData = graphql_tag_1.default `
  fragment appSettingsDetailData on AppSettings {
    version
    appUser {
      ...basicUserDetailData
    }
    allowSignups
    enableMagicLinks
    allowUsersToCreateWorkspaces
    requireWorkspacesToHavePaymentMethod
    removeHideablesOnCampaignSend
    removeOsysTagsOnCampaignSend
    minifyOnCampaignSend
    minifySettings
    environment
    logLevel
    adminEmailAddress
    siteUrl
    featureFlagOverrides {
      ...featureFlagsDetailData
    }
  }
  ${users_1.basicUserDetailData}
  ${featureFlagsDetailData_1.featureFlagsDetailData}
`;
//# sourceMappingURL=appSettings.js.map